import type { StreamLang } from './detectStreamLanguage';

/** Lingua UI stream da evento SSE `response_language` (source of truth = API languageDetectionHelper). */
export function mapStreamResponseLanguage(
  language: 'it' | 'en' | 'de' | 'fr' | 'es',
): StreamLang {
  if (language === 'de' || language === 'fr' || language === 'es') {
    return language;
  }
  return language === 'it' ? 'it' : 'en';
}
